import React, { memo } from "react";

// Libraries
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { PropTypes } from "prop-types";

// Components
import SocialIcons from "../SocialIcon/SocialIcons";
import FooterMenu, { Footer } from "./Footer";
import StaticInstagram from "../Instagram/StaticInstagram";

// Data
import FooterData from "./FooterData";
import { color } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faGlobe } from "@fortawesome/free-solid-svg-icons";
import WhatsAppFloatingButton from "../../Pages/ecd-pages/WhatsAppFloatingButton ";

const iconData = [
  {
    color: "#828282",
    link: "https://www.facebook.com/",
    icon: "fab fa-facebook-f",
  },
  {
    color: "#828282",
    link: "https://dribbble.com/",
    icon: "fab fa-dribbble",
  },
  {
    color: "#828282",
    link: "https://twitter.com/",
    icon: "fab fa-twitter",
  },
  {
    color: "#828282",
    link: "https://www.instagram.com/",
    icon: "fab fa-instagram",
  },
];

const FooterStyle01 = (props) => {
  return (
    <Footer
      theme={props.theme}
      className={`${props.className ? ` ${props.className}` : ""}`}
      style={{
        backgroundColor: props.theme === "dark" ? "#4c934c" : "#4c934c",
        color: "#100C08",
      }}
      fluid="fluid"
    >
      <div className="py-[1%] lg:py-[55px] md:py-[10px]">
        <Container>
          <Row>
            <Col lg={10} sm={6} className="xs:mb-[25px]">
              <span
                className="mb-[20px] font-serif block font-medium text-themecolor xs:mb-[10px]"
                style={{
                  color: "#0a0a0a",
                  fontSize: "17px",
                  //   fontFamily: "sans-serif",
                  fontWeight: "bold",
                }}
              >
                Get in touch
              </span>
              <i className="fa fa-location-arrow site-text-primary text-red-900" />
              <b className="p-lr5 text-uppercase text-red-900 ms-2">
                Office Address :-{" "}
              </b>
              <p className="w-[85%] mb-[15px] ptag">
                501, 5th floor, Shapath-1, Nr. Gordhanthal, Pakwan Opp. Rajpath
                Club, S.G. Highway, Ahmedabad 380 054, Gujarat, India.
              </p>
              <i className="fa fa-location-arrow site-text-primary text-red-900" />
              <b className="p-lr5 text-uppercase text-red-900 ms-2">
                Registered Address :-{" "}
              </b>
              <p className="w-[85%] mb-[15px] ptag">
                560-Avadh Shangrila, Baleshwar, Sanskar Vidhya Sankul, Palsana,
                Gujarat 394 315
              </p>
              <div>
                <i className="feather-phone-call text-sm mr-[10px] text-red-900"></i>
                +91 97129 24365
                {/* +91 94270 17207 | +91 97260 69272 */}
              </div>
              <div>
                {/* <i className="feather-mail text-sm mr-[10px] text-red-900"></i>
                <a
                  aria-label="mail"
                  href="mailTo:revinder@echobuildlimited.com"
                >
                  revinder@echobuildlimited.com
                </a> */}
                <p className="mb-2">
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    className="mr-2 text-[#991f00]"
                  />
                  info@ecobuildlimited.com
                </p>
                <p>
                  <FontAwesomeIcon
                    icon={faGlobe}
                    className="mr-2 text-[#991f00]"
                  />
                  <a
                    href="https://www.ecobuildlimited.com"
                    className="text-blue-600 hover:underline"
                    target="_blank"
                    rel="noreferrer"
                  >
                    www.ecobuildlimited.com
                  </a>
                </p>
              </div>
            </Col>
            <FooterMenu
              data={FooterData.slice(0, 2)}
              lg={2}
              sm={6}
              className="xl:px-[15px] md:mb-[40px] xs:mb-[25px]"
              titleClass="capitalize"
            />
            {/* <Col lg={3} sm={6}>
              <span
                className="mb-[20px] font-medium font-serif text-themecolor block xs:mb-[20px]"
                style={{
                  color: "#0a0a0a",
                  fontSize: "17px",
                  //   fontFamily: "sans-serif",
                  fontWeight: "bold",
                }}
              >
                Follow us on Instagram
              </span>
              <div className="w-full inline-block">
                <StaticInstagram total_posts={3} />
                <a
                  aria-label="link"
                  rel="noreferrer"
                  href="https://www.instagram.com/"
                  target="_blank"
                  className="flex justify-start text-slateblue font-medium text-xs font-serif uppercase mt-[20px] items-center hover:text-primary"
                >
                  <i className="fab fa-instagram text-lg mr-[10px] text-gradient bg-gradient-to-r from-[#ff85a6] to-[#b783ff]"></i>
                  <span className="inline-block text-dark hover:text-light">
                    Follow instagram
                  </span>
                </a>
              </div>
            </Col> */}
          </Row>
          <WhatsAppFloatingButton />
        </Container>
      </div>
      <div className="py-[5px] border-t border-[#100C08]">
        <Container>
          <Row>
            <Col md={3} className="sm:mb-[20px]">
              <Link
                aria-label="homepage"
                to="/"
                className="sm:flex sm:justify-center"
              >
                <img alt="logo" src={props.logo} width="150" height="36" />
              </Link>
            </Col>
            <Col
              md={6}
              className="flex flex-col justify-center items-center text-center sm:mb-[20px]"
            >
              <p className="mb-1 ptag">
                &copy; Copyright {new Date().getFullYear()} ECD All rights
                reserved . Read Legal policy and Privacy policy.
              </p>
              <a
                href="https://www.agmetech.com/"
                target="_blank"
                rel="noreferrer"
                className="cursor-pointer"
              >
                {" "}
                Web Development by AGM Etech Private Limited.
              </a>
            </Col>
            <Col md={3} className="text-right sm:text-center">
              <SocialIcons
                size="xs"
                theme="social-icon-style-01"
                className="justify-end sm:justify-center"
                iconColor={props.theme === "dark" ? "white" : "dark"}
                data={iconData}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </Footer>
  );
};

FooterStyle01.defaultProps = {
  data: FooterData,
  // className: "bg-[#4c934c] text-[#0a0a0a]",
  // logo: "/assets/logo/Neevo-small.png",
  // theme: "light",
};

FooterStyle01.propTypes = {
  className: PropTypes.string,
  logo: PropTypes.string,
};

export default memo(FooterStyle01);
